import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import fetch, { IBaseResponse } from 'lib/decorated-fetch'
import getUrl from 'lib/url'

import { AD_RIT } from 'Constants/ad'

type DealerAdParams = {
  city_name: string
  rit_ids: string
}

export type DealerAdInfo = {
  [key in AD_RIT]: DealerAdItemInfo
}

export type DealerAdItemInfo = {
  ad_group_id_str: string
  ad_log_id: string
  ad_price_type: string
  convert_id: string
  id: number
  id_str: string
  image_left_big?: ImageData //双图使用
  image_right_big?: ImageData //双图使用
  is_preview: boolean
  label: string
  log_extra: string
  materiel_id: string
  materiel_str: string
  rit: number
  rit_str: AD_RIT
  web_title: string
  web_url: string
  image?: ImageData //单图使用
  tag?: string //文字链使用
  text?: string //文字链使用
}

type TeaValue = string | number | undefined

export type TeaParams = {
  page_id: string
  [key: string]: TeaValue
}

export type ImageData = {
  height: number
  url: string
  width: number
  objectFit?:
    | 'fill'
    | '-moz-initial'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'unset'
    | 'contain'
    | 'cover'
    | 'none'
    | 'scale-down'
    | undefined
}

const getDealerAdInfo = async (params: DealerAdParams) => {
  const res: IBaseResponse<DealerAdInfo> = await fetch(
    getUrl(`/motor/dealer_ad/pc/ad_data?${serializeObject(params)}`)
  )
  return res.data
}

export default getDealerAdInfo
